/* Because — the "skip the trial" offer, made AT trial checkout. Vanilla JS, no dependencies.
   Rendered by snippets/skip-trial-offer.liquid; see that file for the offer's mechanism and
   for why it currently lives outside sections/trial-lp.liquid.

   It intercepts the trial CTA, asks once, and then either checks the shopper out on a
   subscription or hands the tap back to the page untouched. No-ops entirely when its config
   or its dialog is absent, so removing the snippet removes the offer. */
(function () {
  var cfgEl = document.getElementById('skiptrial-config');
  var dlg = document.getElementById('skipTrialModal');
  var form = document.querySelector('.selector');
  if (!cfgEl || !dlg || !form) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.sellingPlan || !cfg.variants) return;

  var PCT = cfg.pct === undefined || cfg.pct === null || cfg.pct === '' ? 0 : Number(cfg.pct);
  if (!(PCT >= 0)) PCT = 0;

  // Packs per delivery. This offer sells a SUBSCRIPTION DELIVERY, and a delivery on these
  // products is two packs — see the `qty` note in snippets/skip-trial-offer.liquid for the
  // three sources that agree on it. Defaulting to 1 if the config omits it would silently
  // reintroduce the bug, so an absent or unusable value is refused below instead.
  var QTY = Math.floor(Number(cfg.quantity));

  // ── The switch ──
  // Three inputs, most specific first. The URL parameter is for looking at it yourself;
  // window.BM_SKIPTRIAL is what Intelligems sets per visitor; the config's `enabled` is the
  // committed default, and since the 2026-09-02 rollout it is TRUE on both trial LPs.
  //
  // That inverts what the window flag is for. It used to be the way IN — the offer was dark
  // and Intelligems armed it for half the visitors of /pages/start-full-trial. Now it is the
  // way OUT: an explicit `false` takes the offer down on both pages within minutes and with
  // no deploy, while leaving it unset (what the control arm always did — it injected
  // nothing) is the rolled-out state. Read it as a kill switch, not as an experiment.
  //
  // ASKED LATE, ON PURPOSE. This used to resolve once at load and `return` when false, and
  // that silently lost the A/B: this script is DEFERRED, Intelligems assigns the flag from
  // its own script, and when its assignment lands second the deferred read has already seen
  // `undefined`, taken the committed default (false at the time) and torn down — with no
  // listener left to change its mind. Turning the experiment on did nothing, with nothing in
  // the console to say why. The same race is now what makes the kill switch work: a `false`
  // injected after this script runs is still seen at the tap.
  //
  // The fix is not a poller or a timer; it is simply asking later. Nothing needs the answer
  // at load — only two moments do, and both are human interactions seconds into the page's
  // life, by which time any injected experiment variable has long since been set:
  //   - the first fit-test answer, to decide whether to start the fraud gate
  //   - the tap, to decide whether to show the offer
  // A visitor whose offer has been killed therefore costs one no-op listener and no requests.
  var param = null;
  try { param = new URLSearchParams(window.location.search).get('skiptrial'); } catch (e) {}

  // A percentage with no code behind it is a button that promises a discount the checkout
  // will not give. It is the exact failure this offer died of once (`40off` expired and the
  // pages kept selling against it for two months), so it is refused before anything is shown
  // rather than discovered per-order. Same for a quantity the config did not state: it would
  // put a price in the dialog that does not match the cart. Either way the tap is left alone
  // and the trial is untouched. Logged once, and only for a visitor the offer was actually
  // meant for — a dark page with no code yet is a valid state, not an error.
  var warned = false;
  var refuse = function (msg, detail) {
    if (!warned) { warned = true; console.error('skip-trial: ' + msg, detail === undefined ? '' : detail); }
    return false;
  };
  var armed = function () {
    var on;
    if (param !== null) on = !/^(0|false|off|no)$/i.test(param.trim());
    else if (typeof window.BM_SKIPTRIAL !== 'undefined') on = !!window.BM_SKIPTRIAL;
    else on = cfg.enabled === true;
    if (!on) return false;
    if (PCT > 0 && !cfg.code) return refuse('armed with ' + PCT + '% and no discount code — offer not shown');
    if (!(QTY >= 1)) return refuse('no usable quantity in config — offer not shown', cfg.quantity);
    return true;
  };

  // ── The fraud gate ──
  // Before the offer is shown, the fraud app (portofinolabs/guardian) is asked whether this
  // BROWSER may take a new-customer discount. The abuse this exists for is one person taking
  // the offer repeatedly behind fresh email addresses: a new account defeats the discount's
  // customer segment and its once-per-customer limit, because a new account has, truthfully,
  // never purchased. The browser is the thing that does not change, so the browser is what
  // gets asked about.
  //
  // The id is `_cc_p`, written by assets/cc-session.js as a cart attribute and read back
  // from the cart rather than recomputed here — that way the value we ask about is exactly
  // the value that will land on the order, with no second implementation of the hash to
  // drift.
  //
  // …falling back to `window.__ccDevice`, which cc-session.js sets synchronously with that
  // same hash. The cart attribute can genuinely be missing: several apps POST
  // /cart/update.js at page load (Intelligems, Littledata, oai-attribution, Rebuy) and
  // concurrent writes clobber each other, so ours is sometimes not on the cart yet or at
  // all. Without this fallback the gate is asked about an EMPTY device, refuses by design,
  // and the offer never opens — which is exactly what a shopper reported on 2026-09-04, on
  // a cart carrying every other app's attributes and not ours. cc-session.js now verifies
  // and retries its write; this is the second half, so a lost write costs the order its
  // linking data rather than costing the shopper the offer.
  //
  // TIMING. The check starts on the first fit-test answer, not on page load (no cost for
  // visitors who never engage) and not on the tap (no latency in front of the modal). By the
  // time anyone taps, it has long since resolved.
  //
  // UNRESOLVED MEANS NO. The click handler cannot wait — it has to decide synchronously
  // whether to intercept — so anything other than a definite yes lets the tap through to the
  // ordinary $9.99 trial. Fail open for the product, fail closed for the discount. That also
  // means this ships safely before the app proxy exists: every call 404s, the answer is never
  // yes, and the offer simply stays dark.
  var gateUrl = cfg.gateUrl || '/apps/cove/guardian/offer-check';
  var gate = null;              // null = unknown/pending, true = allowed, false = refused
  var gateStarted = false;
  var gatePromise = null;

  var startGate = function () {
    if (gateStarted) return gatePromise;
    if (!armed()) return Promise.resolve(false);
    gateStarted = true;
    gatePromise = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var deviceId = (cart && cart.attributes && cart.attributes._cc_p) || window.__ccDevice || '';
        return fetch(gateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ offer: 'skiptrial', deviceId: deviceId || '' })
        });
      })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (out) { gate = !!(out && out.allow === true); return gate; })
      .catch(function () { gate = false; return false; });
    return gatePromise;
  };
  form.addEventListener('change', startGate);

  var accept = dlg.querySelector('.skiptrial-accept');
  var decline = dlg.querySelector('.skiptrial-decline');
  var nowEl = dlg.querySelector('[data-skiptrial-price-now]');
  var thenEl = dlg.querySelector('[data-skiptrial-price-then]');
  var errEl = dlg.querySelector('[data-skiptrial-error]');
  if (!accept || !decline) return;
  var acceptHtml = accept.innerHTML;

  // ASKED ON EVERY TAP. There is no memory of a previous refusal — not per selection, not
  // per tab. Tap the trial CTA, see the offer; decline, tap again, see it again.
  //
  // This replaced a once-per-selection memory (sessionStorage `bm_skiptrial_declined`) on
  // 2026-09-04, by product decision. The argument for remembering was that a shopper who
  // said no should not have to dismiss a modal every time they try to do the thing they came
  // for. The argument against, which won: dismissal is not the same as refusal. An X, an Esc
  // or a mis-tap on the backdrop — easy on a phone, easier for this audience — silently
  // retired the offer for that selection, and the shopper never learned it existed. Rather
  // than split the two cases, the offer now simply asks again.
  //
  // The trial is never blocked by this: declining re-dispatches the tap, so the $9.99/$6.99
  // checkout is always exactly one more tap away, and the decline button sits at full size
  // under the accept.

  var val = function (name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  };
  // Same key shape the section's own offers use, built from whichever steps the page has:
  // "Women|Overnight|L" on the underwear LP, "Women|Overnight" on the size-less pads LP.
  var selectionKey = function () {
    return ['gender', 'abs', 'size'].map(val).filter(Boolean).join('|');
  };
  var chosen = function () { return cfg.variants[selectionKey()] || null; };

  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
  // Shopify discounts PER UNIT and floors each to the cent, then multiplies — not
  // percent-of-line. Matching it exactly is what keeps the price in the dialog equal to
  // the price at checkout; sections/trial-lp.liquid's 3-pack carries the same note and the
  // draftOrderCalculate check behind it. `plan` comes from the variant's live selling-plan
  // allocation, so the "then" figure is whatever Loop currently charges.
  // Per UNIT first, then multiplied — never percent-of-line. Shopify discounts each unit and
  // floors it to the cent, so at QTY 2 the two roundings are taken separately and the totals
  // differ from a single percentage off the line by up to a cent. Matching it exactly is what
  // keeps the dialog's number equal to the checkout's.
  var unitFirst = function (v) { return v.plan - Math.floor(v.plan * PCT / 100); };
  // What they pay today, and what the subscription becomes: both for the whole delivery,
  // because that is what the cart will hold.
  var firstPrice = function (v) { return unitFirst(v) * QTY; };
  var thenPrice = function (v) { return v.plan * QTY; };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  // ── The intercept ──
  // CAPTURE phase on the form, so this runs before the section's own listener on the
  // button regardless of which script loaded first: stopping propagation here means the
  // event never reaches the target and the trial checkout never starts.
  //
  // Every early return below is a deliberate fail-open. If the offer cannot be made —
  // no size yet (the section's own handler prompts for it, and should), no variant, sold
  // out — the tap passes through and the trial behaves exactly as before.
  var passThrough = false;
  form.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.trial-cta');
    if (!btn || !form.contains(btn) || btn.disabled) return;

    if (passThrough) { passThrough = false; return; }   // the decline re-dispatch
    if (!armed()) return;
    if (gate !== true) return;                          // refused, or not answered yet

    var sizeInput = form.querySelector('input[name="size"]');
    if (sizeInput && !val('size')) return;              // let the section ask for a size

    var v = chosen();
    if (!v || v.available === false) return;
    // The choice-card dialog quotes the plan price as "a month"; a size with no plan
    // allocation (plan falls back to the one-time price) would make that untrue, so the
    // offer steps aside and the trial proceeds (legal review, panel P8).
    if (decline.classList.contains('skiptrial-choice') && !(Number(v.plan) < Number(v.full))) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    setMode(false);
    openOffer(btn, v);
  }, true);

  // The offer was SHOWN. Written before the shopper answers, so it lands on the order
  // whichever way they go — a take-rate needs the orders that saw the offer and did not
  // take it just as much as the ones that did. Fire-and-forget: this must never delay or
  // block either path. /cart/clear does not remove attributes, so the trial's own cart
  // writes downstream do not wipe it.
  var stampShown = function (outcome) {
    // A page with its own cart-write queue (the clear LP's window.clrCartAttrs) gets the stamp
    // through it, so it cannot race the trial's own writes; elsewhere, as before.
    // It is also kept in window.clrCartBase, which trial-lp.js folds into its last write
    // before checkout, so a decline is on the order even if this write is cut off.
    if (typeof window.clrCartAttrs === 'function') {
      try { if (window.clrCartBase) window.clrCartBase['Skip trial offer'] = outcome; window.clrCartAttrs({ 'Skip trial offer': outcome }); return; } catch (e) {}
    }
    try {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Skip trial offer': outcome } }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  };

  // ── The offer as a button ──
  // A page may also show this offer as a visible button beside the trial CTA
  // (`.skiptrial-direct`, under a form carrying data-direct-offers="true"). The intercept
  // above still runs on the trial tap; this is the same dialog, opened deliberately. The
  // dialog is shared, so its labels are set per opening: "No thanks — start my trial" is
  // the way out for someone who was on their way to the trial, "Back" for someone who
  // came from this button. The button is revealed only once the fraud gate has said yes,
  // so it is never a dead control, and the gate is asked at load rather than on the first
  // fit-test answer because the button is on screen from the start.
  var direct = form.dataset.directOffers === 'true';
  var directBtn = form.querySelector('.skiptrial-direct');
  var directWrap = form.querySelector('[data-skiptrial-direct-wrap]');
  var directPrice = form.querySelector('[data-skiptrial-direct-price]');
  var directStatus = form.querySelector('[data-acq-skip-status]');
  var directBusy = false;
  var directMode = false;
  var titleEl = document.getElementById('skipTrialTitle');
  // Markup, not text: the clear LP's title holds an amount span that fillAmounts fills.
  var baseTitle = titleEl ? titleEl.innerHTML : '';
  // A rich decline (a choice card) names itself in a label span; swap only that, so the
  // card's price and dates survive. Elsewhere the button is its own label.
  var declineLabel = decline.querySelector('[data-skiptrial-decline-label]') || decline;
  var baseDecline = declineLabel.textContent;
  var setMode = function (isDirect) {
    directMode = isDirect;
    if (titleEl) { if (isDirect) titleEl.textContent = 'Subscribe now, ' + PCT + '% off today'; else titleEl.innerHTML = baseTitle; }
    declineLabel.textContent = isDirect ? 'Back' : baseDecline;
  };
  // Shipping as the checkout will charge it: $7.99 under the free-shipping floor. The
  // dialog quotes delivered totals so its numbers match the page's own disclosure.
  var withShipping = function (cents) { return cents + (cents >= 7500 ? 0 : 799); };
  var withShippingTotal = withShipping;
  if (direct && directBtn) {
    var paintDirect = function () {
      var v = chosen();
      var ok = armed() && v && v.available !== false;
      if (directPrice) directPrice.textContent = ok ? money(withShipping(firstPrice(v))) + ' today' : (val('size') && v && v.available === false ? 'Unavailable in this size' : PCT + '% off your first order');
      directBtn.disabled = !!(v && v.available === false);
    };
    form.addEventListener('change', paintDirect);
    window.addEventListener('pageshow', paintDirect);
    paintDirect();
    if (directWrap) {
      startGate().then(function (allowed) { directWrap.hidden = allowed !== true; });
    }
    directBtn.addEventListener('click', function () {
      if (directBusy) return;
      if (directStatus) directStatus.textContent = '';
      var size = form.querySelector('input[name="size"]');
      if (size && !val('size')) {
        var hint = document.getElementById('sizeRequired');
        if (hint) { hint.hidden = false; hint.textContent = 'Please choose your size to continue.'; hint.classList.add('is-alert'); }
        var step = size.closest('.selector__step');
        if (step) { step.classList.add('is-invalid'); step.scrollIntoView({ block: 'center' }); }
        return;
      }
      var v = chosen();
      if (!v || v.available === false || !armed()) {
        if (directStatus) directStatus.textContent = 'This offer is not available for that selection.';
        return;
      }
      var requested = selectionKey();
      directBusy = true; directBtn.disabled = true;
      Promise.race([startGate(), new Promise(function (resolve) { setTimeout(function () { resolve(null); }, 10000); })]).then(function (allowed) {
        directBusy = false; directBtn.disabled = false;
        if (requested !== selectionKey()) return;
        var cur = chosen();
        if (allowed === true && armed() && cur && cur.available !== false) { setMode(true); openOffer(directBtn, cur); }
        else if (directStatus) directStatus.textContent = 'We could not confirm this offer just now. Please try again, or call (855) 231-4248.';
        if (allowed !== true) { gateStarted = false; gatePromise = null; }
      });
    });
  }
  var trialBtn = null;
  var packEl = dlg.querySelector('[data-skiptrial-pack]');
  // The buy box's own product image, which the section swaps per absorbency. Copying it
  // in means the dialog shows the pack they actually picked, with no second asset to
  // keep in step; if the page has no such image the element just stays hidden.
  var paintPack = function () {
    // Looked up each time: a dialog whose accept button carries the image gets that
    // markup rebuilt on open and after a failed checkout.
    packEl = dlg.querySelector('[data-skiptrial-pack]');
    if (!packEl) return;
    var src = document.getElementById('selectorProduct');
    var url = src && (src.currentSrc || src.getAttribute('src'));
    if (!url) { packEl.hidden = true; return; }
    packEl.src = url;
    packEl.hidden = false;
  };
  // Bare amounts, for a dialog that lays the prices out itself (the clear LP's copy). Run on
  // open and again after a failed checkout, which restores the accept button's markup.
  var fillAmounts = function (v) {
    // data-ship-separate (the clear LP): store prices, with shipping on its own line as at
    // checkout; elsewhere the delivered totals.
    var sep = dlg.hasAttribute('data-ship-separate');
    var withShipping = sep ? function (c) { return c; } : withShippingTotal;
    var shipOf = function (c) { return c >= 7500 ? 0 : 799; };
    dlg.querySelectorAll('[data-skiptrial-ship]').forEach(function (el) {
      var s = shipOf(el.getAttribute('data-skiptrial-ship') === 'month' ? thenPrice(v) : firstPrice(v));
      el.textContent = '+ ' + money(s) + ' shipping';
      el.hidden = !(sep && s > 0);
    });
    var firstAmt = dlg.querySelectorAll('[data-skiptrial-price-first]');
    var monthAmt = dlg.querySelectorAll('[data-skiptrial-price-month]');
    firstAmt.forEach(function (el) { el.textContent = money(withShipping(firstPrice(v))); });
    monthAmt.forEach(function (el) { el.textContent = money(withShipping(thenPrice(v))); });
    // What skipping saves on the first order against the plan's own monthly price.
    dlg.querySelectorAll('[data-skiptrial-price-was]').forEach(function (el) { el.textContent = money(withShipping(thenPrice(v))); });
    var save = withShipping(thenPrice(v)) - withShipping(firstPrice(v));
    dlg.querySelectorAll('[data-skiptrial-price-save]').forEach(function (el) { el.textContent = money(save); });
    // No saving, no comparison: a struck price beside "$0.00 off" would be a false reference.
    dlg.querySelectorAll('[data-skiptrial-if-save]').forEach(function (el) { el.hidden = !(save > 0); });
  };
  // One accept attempt at a time. Closing, the 15s timeout and a back/forward-cache restore
  // all end the current attempt, so a late reply cannot carry the shopper to checkout, and
  // the cards come back unlocked.
  var attempt = 0, busyTimer = null, busyV = null, inflight = null;
  var stopAttempt = function () {
    attempt++;
    clearTimeout(busyTimer);
    if (!choiceCards || !accept.disabled) return;
    accept.disabled = false;
    accept.innerHTML = acceptHtml;
    { decline.disabled = false; accept.removeAttribute('aria-busy'); if (busyV) fillAmounts(busyV); paintPack(); }
  };
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !choiceCards) return;
    stopAttempt();
    // Back from checkout: the answer on file is no longer "accepted".
    if (window.clrCartBase && window.clrCartBase['Skip trial offer'] === 'shown, accepted') window.clrCartBase['Skip trial offer'] = 'shown, dismissed';
    if (dlg.open && typeof dlg.close === 'function') dlg.close();
  });
  // Choice cards sit side by side as equals, so while the subscription is being set up the
  // other one is locked too: a second tap must not start the trial underneath it.
  var choiceCards = decline.classList.contains('skiptrial-choice');
  var openOffer = function (btn, v) {
    trialBtn = btn;
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    accept.disabled = false;
    accept.innerHTML = acceptHtml;
    if (choiceCards) decline.disabled = false;
    paintPack();
    if (nowEl) nowEl.textContent = money(withShipping(firstPrice(v))) + ' today';
    if (thenEl) thenEl.textContent = 'then ' + money(withShipping(thenPrice(v))) + ' a month until you cancel';
    fillAmounts(v);
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    // Focus the TITLE, not the accept button. Landing on accept meant a keyboard or
    // screen-reader user heard "Get 40% off today, button" and nothing else — no price,
    // no hint that declining was an option, one Enter away from buying. Focusing the
    // heading announces what this dialog is and leaves both buttons a Tab away.
    if (titleEl && typeof titleEl.focus === 'function') titleEl.focus();
    else accept.focus();
    stampShown(directMode ? 'shown (button)' : 'shown');
    if (choiceCards) track('skiptrial_shown', { source: 'trial_lp_skiptrial' });
  };

  // Closing is CANCEL, not consent: it returns to the page rather than continuing to
  // checkout, because an X that silently buys something is a trap. It records nothing, so
  // the next tap on the trial CTA asks again — a dismissal is not an answer.
  var closeOffer = function () {
    stopAttempt();
    stampShown('shown, dismissed');
    if (typeof dlg.close === 'function' && dlg.open) dlg.close();
    else dlg.removeAttribute('open');
    if (trialBtn) trialBtn.focus();
  };
  dlg.addEventListener('click', function (e) { if (e.target === dlg) closeOffer(); });
  // Esc closes a native dialog without a click; record it as the dismissal it is.
  dlg.addEventListener('cancel', function () {
    stopAttempt();
    stampShown('shown, dismissed');
    if (trialBtn) setTimeout(function () { trialBtn.focus(); }, 0);
  });
  var dismiss = dlg.querySelector('[data-skiptrial-dismiss]');
  if (dismiss) dismiss.addEventListener('click', closeOffer);

  // Declining is the one path that continues: re-dispatch the tap they already made, with
  // the intercept standing down for exactly one click, so the section's own trial checkout
  // runs untouched.
  decline.addEventListener('click', function () {
    if (directMode) { closeOffer(); return; }
    if (decline.disabled) return;
    stampShown('shown, declined');
    if (choiceCards) track('skiptrial_declined', { source: 'trial_lp_skiptrial' });
    var shut = function () {
      if (typeof dlg.close === 'function' && dlg.open) dlg.close();
      else dlg.removeAttribute('open');
    };
    if (!trialBtn) { shut(); return; }
    // If a closed or timed-out skip attempt still has a cart request in flight, let it
    // settle first: the trial checkout then clears the cart AFTER it, never before. The
    // dialog stays open meanwhile with the trial card saying so, so nothing looks dead and
    // a second tap cannot reopen the offer under the delayed click.
    var go = function () {
      decline.disabled = false; declineLabel.textContent = baseDecline;
      shut(); passThrough = true; trialBtn.click();
    };
    if (choiceCards && inflight) {
      // …but never longer than 5s: a request that hangs outright must not hold up the trial.
      decline.disabled = true; declineLabel.textContent = 'One moment…';
      var done = false, once = function () { if (!done) { done = true; inflight = null; go(); } };
      inflight.then(once, once);
      setTimeout(once, 5000);
    } else go();
  });

  // ── Analytics ──
  // Consent gate (CIPA): an explicit refusal drops the event entirely. Silence from the
  // API — not loaded yet, no banner — counts as allowed.
  var canTrack = function () {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !(cp && typeof cp.userCanBeTracked === 'function' && !cp.userCanBeTracked());
  };
  // gtag is the ONLY path to GA4 on this storefront (Littledata/Analyzify app embeds, no
  // GTM container), so a dataLayer push alone goes nowhere; it is kept for a future
  // listener. Deliberately not named begin_checkout — Littledata fires that on the real
  // checkout and reusing the name would double-count the step.
  var track = function (name, props) {
    if (!canTrack()) return;
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
    var payload = { event: name };
    for (var k in props) if (Object.prototype.hasOwnProperty.call(props, k)) payload[k] = props[k];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  // ── Checkout ──
  var postJson = function (path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.ok) return r.json();
      // Carry the status out with the body: a 422 is the server REFUSING the line and
      // saying why, anything else (429 bot challenge, 5xx, dropped connection) means we
      // were told nothing. Reporting silence as a refusal is the expensive mistake.
      return r.json().then(
        function (e) { e = e || {}; e.status = r.status; throw e; },
        function () { var e = new Error(path + ' ' + r.status); e.status = r.status; throw e; }
      );
    });
  };

  // Fit-test answers as CART ATTRIBUTES, so they land on the order's "Additional details"
  // in admin alongside the variant. First-party order data, so not consent-gated.
  var cartAttrs = function (offer) {
    var attrs = {
      'Fit test — Who it\'s for': val('gender') || '',
      'Fit test — Protection level': val('abs') || '',
      'Fit test — Size': val('size') || '',
      'Offer': offer
    };
    try {
      var oai = window.oaiAttribution && window.oaiAttribution.cartAttributes();
      for (var k in oai) if (Object.prototype.hasOwnProperty.call(oai, k)) attrs[k] = oai[k];
    } catch (e) {}
    // The page's own attribution (the clear LP's _lp / _lead_offer), when it has any.
    try {
      var base = window.clrCartBase;
      for (var b in base) if (Object.prototype.hasOwnProperty.call(base, b)) attrs[b] = base[b];
    } catch (e) {}
    // Ad click ids + Meta's _fbc/_fbp as hidden attributes ({} without consent); see
    // window.bcmAdIds in snippets/defer-third-party.liquid.
    try {
      var ad = window.bcmAdIds && window.bcmAdIds.cartAttributes();
      for (var a in ad) if (Object.prototype.hasOwnProperty.call(ad, a)) attrs[a] = ad[a];
    } catch (e) {}
    return attrs;
  };

  // Apply the code, then CONFIRM the cart actually got discounted. An expired or
  // mis-scoped code would otherwise bill full price silently — which is exactly how this
  // offer died the first time: `40off` expired on 2026-07-01 and the pages kept sending
  // people to checkout at the plain subscription price for two months. The verdict is
  // written onto the order below, so a broken offer shows up in admin instead of only in
  // lost margin. A `false` here means the OFFER is misconfigured, not that this shopper
  // was turned down — the cart is anonymous at this point.
  var applyDiscount = function (code) {
    if (!code) return Promise.resolve(false);
    // One request: the Ajax cart applies the code and answers with the cart (it used to
    // GET /discount/CODE, which redirects to the ~340 KB homepage, then fetch cart.js).
    return postJson('cart/update.js', { discount: code })
      .then(function (cart) { return !!(cart && Number(cart.total_discount) > 0); })
      .catch(function () { return false; });
  };

  accept.addEventListener('click', function () {
    if (accept.disabled) return;
    var sel = selectionKey();
    var v = chosen();
    // The dialog only opens on a resolved selection, so this is belt-and-braces: if the
    // selection changed underneath it, hand the shopper back to the trial rather than
    // stranding them on a dead button.
    if (!v) { closeOffer(); return; }

    track('skiptrial_begin_checkout', {
      variant_id: v.id,
      value: firstPrice(v) / 100,
      trial_selection: sel,
      source: 'trial_lp_skiptrial'
    });

    if (errEl) errEl.hidden = true;
    accept.disabled = true;
    if (choiceCards) { decline.disabled = true; accept.setAttribute('aria-busy', 'true'); }
    accept.textContent = 'Setting up your subscription…';
    var my = ++attempt;
    busyV = v;
    if (window.clrCartBase) window.clrCartBase['Skip trial offer'] = 'shown, accepted';
    // Choice-card dialogs (the clear LP) give up after 15s rather than leave both choices
    // locked on a hung request: the cards unlock and the dialog says to try again.
    if (choiceCards) {
      clearTimeout(busyTimer);
      busyTimer = setTimeout(function () {
        if (my !== attempt) return;
        stopAttempt();
        if (errEl) { errEl.textContent = 'Sorry, that took too long, so no order was placed. Please try again.'; errEl.hidden = false; }
      }, 15000);
    }

    // clear -> add the retail variant ON THE SUBSCRIPTION PLAN -> apply the first-order
    // code -> stamp what actually happened -> checkout. Attributes are written last of the
    // cart writes but still before the redirect, so the clear cannot wipe them.
    // Each step checks the attempt is still live, so a closed or timed-out attempt stops
    // writing to the cart at the next step (no skip item, code or outcome after a decline).
    var live = function (x) { if (choiceCards && my !== attempt) { var a = new Error('abandoned'); a.abandoned = true; throw a; } return x; };
    // A retry after a timeout waits (≤5s) for the previous attempt's last request, so its
    // late cart/add cannot land after this clear and double the packs.
    var prior = inflight;
    var settled = prior ? new Promise(function (res) { prior.then(res, res); setTimeout(res, 5000); }) : Promise.resolve();
    inflight = settled
      .then(live)
      .then(function () { return window.lpPrepCart ? window.lpPrepCart() : postJson('cart/clear.js', {}); })
      .then(live)
      .then(function () {
        return postJson('cart/add.js', {
          items: [{ id: Number(v.id), quantity: QTY, selling_plan: Number(cfg.sellingPlan) }]
        });
      })
      .then(live)
      .then(function () { return applyDiscount(cfg.code); })
      .then(live)
      .then(function (applied) {
        // THE OFFER IS THE DISCOUNT. If the code did not actually discount the cart, this
        // stops here rather than sending the shopper to checkout — subscribing someone on
        // a promise of 40% off and then billing them the plain plan price is the failure
        // this whole offer died of, and it must not be reachable by accident. The 3-pack
        // proceeds in the same situation, correctly: it is a one-time purchase at 20%, not
        // a recurring commitment taken under a false price.
        if (cfg.code && !applied) {
          console.error('skip-trial: discount did not apply, aborting checkout', cfg.code);
          var e = new Error('discount did not apply');
          e.discountFailed = true;
          throw e;
        }
        var state = cfg.code ? PCT + '% off first order' : 'plan price, no first-order code';
        return postJson('cart/update.js', { attributes: cartAttrs('Skip trial — subscription (' + state + ')') });
      })
      .then(function () {
        // Closed, timed out or restored from the back/forward cache while this ran: the
        // shopper has left this choice, so do not carry them to checkout.
        if (choiceCards && my !== attempt) return;
        clearTimeout(busyTimer);
        window.location.href = root + 'checkout';
      })
      .catch(function (err) {
        if (err && err.abandoned) return;
        console.error('skip-trial: checkout failed', err);
        if (choiceCards && my !== attempt) return;
        clearTimeout(busyTimer);
        accept.disabled = false;
        accept.innerHTML = acceptHtml;
        if (choiceCards) { decline.disabled = false; accept.removeAttribute('aria-busy'); fillAmounts(v); paintPack(); }
        // Say it inside the dialog — the section's own error panel is behind the backdrop
        // and would go unseen. A refusal carries the server's own words; anything else
        // means we were told nothing, and only says so.
        var reason = (err && (err.description || err.message)) || '';
        var half = reason.split(': ')[0];
        if (half && reason.indexOf(half + ': ' + half) === 0) reason = half;
        var refused = Boolean(err) && err.status === 422 && Boolean(reason);
        var msg;
        if (err && err.discountFailed) {
          // Name the discount, and name the way out. The decline button below is still
          // live, so the $9.99 trial remains one tap away.
          msg = choiceCards
            ? 'Sorry, your discount didn\'t apply, so no order was placed. Please try again, or keep your $9.99 trial box.'
            : 'Sorry — we could not apply your first-order discount just now, so we have not '
              + 'placed the order. Please try again, or return to your offer choices.';
        } else {
          msg = refused ? reason : 'Sorry — we could not set that up just then. Please try again.';
        }
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
        else alert(msg);
      });
  });
})();
